import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class PriceAlertModal extends Component {
	render() { 
		return ( 
			<div>
		  		<Modal isOpen={this.props.isShowModalPriceAlert} toggle={this.props.toggleModalPriceAlert}>
		          	<ModalHeader toggle={this.props.toggleModalPriceAlert}>{strings.title}</ModalHeader>
		          	<ModalBody>
                        <p>{strings.description}</p>
                        <p>{strings.description2}</p>
		          	</ModalBody>
		          	<ModalFooter className="text-center">
						<button 
						  	type="button" 
							className="showtix-button showtix-background__primary-1"
							onClick={this.props.toggleModalPriceAlert}
						>
							<span>{strings.ok}</span>
						</button>
		          	</ModalFooter>
		        </Modal>
			</div>
		)
	}
}

PriceAlertModal.propTypes = {
    isShowModalPriceAlert: PropTypes.bool,
    toggleModalPriceAlert: PropTypes.func,
}
 
export default PriceAlertModal;


// WEBPACK FOOTER //
// ./src/components/CreateEvent/PriceAlertModal/PriceAlertModal.js